import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  GeoAlt,
  Telephone,
  Envelope,
  Globe,
  Clock,
  ArrowRight,
  Facebook,
  Linkedin,
  Instagram,
} from "react-bootstrap-icons";

const Footer = () => {
  // Updated color palette based on your theme
  const colors = {
    background: "#032530", // Dark teal
    cardBg: "#0b2c36", // Medium teal
    text: "#FFFFFF", // White text
    accent: "#ff8214", // Orange accent
    accentHover: "#ff9b44", // Lighter orange for hover
    border: "#1e273d", // Dark blue border
    adminBlue: "#018744", // Green (unused in footer but kept for consistency)
  };

  const officeData = [
    {
      title: "Lahore Office",
      icon: <GeoAlt />,
      details: [
        {
          text: "12 Aibek Block New Garden Town",
          subText: "Near Kaizen High School Lahore",
        },
        {
          text: "Contact: +92 308 8881287 | +92 331 4220805 | +92 316 4798104",
          icon: <Telephone />,
        },
        { text: "info@educationireland.net", icon: <Envelope />, email: true },
      ],
    },

    {
      title: "Islamabad Office",
      icon: <GeoAlt />,
      details: [
        {
          text: "2nd Floor West Wing, Asif Plaza",
          subText: "106-E Fazal-Ul-Haq Road, Blue Area, Islamabad Pakistan",
        },
        {
          text: "Contact: +92 316 4488201 | +92 318 4366632",
          icon: <Telephone />,
        },
        {
          text: "Islamabad@educationireland.net",
          icon: <Envelope />,
          email: true,
        },
      ],
    },

    {
      title: "Karachi Office",
      icon: <GeoAlt />,
      details: [
        {
          text: "Office 503, 5th Floor, Elegant Tower",
          subText: "Plot BC 2, Block 5 Clifton, Karachi",
        },
        {
          text: "Contact: +92 310 4263667 | +92 308 8880137",
          icon: <Telephone />,
        },

        {
          text: "karachi@educationireland.net",
          icon: <Envelope />,
          email: true,
        },
      ],
    },
  ];

  return (
    <footer
      className="footer py-5"
      style={{
        backgroundColor: "#13181f",
        color: colors.text,
        borderTop: `1px solid ${colors.border}`,
      }}
    >
      <Container>
        {/* Main Header */}
        <Row className="mb-5">
          <Col className="text-center">
            <h2
              className="fw-bold mb-3"
              style={{
                color: "white",
                fontSize: "2.5rem",
              }}
            >
              Our Offices & Contacts
            </h2>
            <p className="lead" style={{ opacity: 0.8 }}>
              Your Success Starts Here — Professional Assessment with Expert
              Guidance.
            </p>
          </Col>
        </Row>

        {/* Global Offices Grid */}
        <Row className="mb-5">
          {officeData.map((office, index) => (
            <Col lg={4} md={6} key={index} className="mb-4">
              <div
                className="h-100 p-4"
                style={{
                  backgroundColor: "#13181f",
                  borderRadius: "10px",
                  border: `1px solid ${colors.border}`,
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.borderColor = colors.accent;
                  e.currentTarget.style.boxShadow = `0 5px 20px rgba(255, 130, 20, 0.2)`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.borderColor = colors.border;
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div className="d-flex align-items-center mb-3">
                  <div
                    className="me-3"
                    style={{
                      color: colors.accent,
                      fontSize: "1.2rem",
                    }}
                  >
                    {office.icon}
                  </div>
                  <h5 className="fw-bold mb-0" style={{ color: "#fff" }}>
                    {office.title}
                  </h5>
                </div>

                <div className="office-details">
                  {office.details.map((detail, idx) => (
                    <div
                      key={idx}
                      className="mb-2 d-flex align-items-start"
                      style={{ fontSize: "0.9rem" }}
                    >
                      {detail.icon && (
                        <span
                          className="me-2 mt-1"
                          style={{
                            color: colors.accent,
                            fontSize: "0.8rem",
                            minWidth: "16px",
                          }}
                        >
                          {detail.icon}
                        </span>
                      )}
                      {!detail.icon && (
                        <span className="me-2" style={{ width: "16px" }} />
                      )}
                      <div>
                        <span style={{ opacity: detail.email ? 1 : 0.9 }}>
                          {detail.email ? (
                            <a
                              href={`mailto:${detail.text}`}
                              style={{
                                color: colors.text,
                                textDecoration: "none",
                                transition: "color 0.3s ease",
                              }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.color = colors.accent)
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.color = colors.text)
                              }
                            >
                              {detail.text}
                            </a>
                          ) : (
                            detail.text
                          )}
                        </span>
                        {detail.subText && (
                          <div
                            style={{
                              fontSize: "0.85rem",
                              opacity: 0.7,
                              marginTop: "2px",
                            }}
                          >
                            {detail.subText}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          ))}
        </Row>

        {/* Services & Quick Links */}
        <Row className="mb-4">
          <Col md={4} className="mb-4">
            <h5 style={{ color: colors.accent }} className="mb-3">
              Our Services
            </h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <a
                  href="/assessment"
                  className="text-decoration-none d-flex align-items-center"
                  style={{
                    color: colors.text,
                    opacity: 0.9,
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = colors.accent;
                    e.currentTarget.style.opacity = 1;
                    e.currentTarget.style.transform = "translateX(5px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = colors.text;
                    e.currentTarget.style.opacity = 0.9;
                    e.currentTarget.style.transform = "translateX(0)";
                  }}
                >
                  <ArrowRight className="me-2" size={12} />
                  Free Visa Probability Assessment
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="/booking"
                  className="text-decoration-none d-flex align-items-center"
                  style={{
                    color: colors.text,
                    opacity: 0.9,
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = colors.accent;
                    e.currentTarget.style.opacity = 1;
                    e.currentTarget.style.transform = "translateX(5px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = colors.text;
                    e.currentTarget.style.opacity = 0.9;
                    e.currentTarget.style.transform = "translateX(0)";
                  }}
                >
                  <ArrowRight className="me-2" size={12} />
                  Professional Consultation
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="https://educationireland.net/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none d-flex align-items-center"
                  style={{
                    color: colors.text,
                    opacity: 0.9,
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = colors.accent;
                    e.currentTarget.style.opacity = 1;
                    e.currentTarget.style.transform = "translateX(5px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = colors.text;
                    e.currentTarget.style.opacity = 0.9;
                    e.currentTarget.style.transform = "translateX(0)";
                  }}
                >
                  <ArrowRight className="me-2" size={12} />
                  Education Ireland Website
                </a>
              </li>
            </ul>
          </Col>

          <Col md={4} className="mb-4">
            <h5 style={{ color: colors.accent }} className="mb-3">
              Business Hours
            </h5>
            <div className="d-flex align-items-center mb-3">
              <Clock className="me-2" style={{ color: colors.accent }} />
              <div>
                <div>Monday - Friday: 9:00 AM - 6:00 PM</div>
              </div>
            </div>
            <div className="d-flex align-items-center">
              <Globe className="me-2" style={{ color: colors.accent }} />
              <span>Serving students globally across all timezones</span>
            </div>
          </Col>

          <Col md={4} className="mb-4">
            <h5 style={{ color: colors.accent }} className="mb-3">
              Connect With Us
            </h5>
            <div className="d-flex gap-3">
              <a
                href="https://www.facebook.com/IrelandEducationOffice"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: colors.text,
                  fontSize: "1.2rem",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = colors.accent;
                  e.currentTarget.style.transform = "translateY(-3px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = colors.text;
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <Facebook />
              </a>
              <a
                href="https://www.linkedin.com/company/ireland-education-office/?originalSubdomain=pk"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: colors.text,
                  fontSize: "1.2rem",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = colors.accent;
                  e.currentTarget.style.transform = "translateY(-3px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = colors.text;
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <Linkedin />
              </a>
              <a
                href="https://www.instagram.com/accounts/login/?next=%2Fstudyireland_intl%2F&source=omni_redirect"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: colors.text,
                  fontSize: "1.2rem",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = colors.accent;
                  e.currentTarget.style.transform = "translateY(-3px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = colors.text;
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <Instagram />
              </a>
              <a
                href="mailto:info@educationireland.net"
                style={{
                  color: colors.text,
                  fontSize: "1.2rem",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = colors.accent;
                  e.currentTarget.style.transform = "translateY(-3px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = colors.text;
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <Envelope />
              </a>
            </div>
          </Col>
        </Row>

        {/* Divider */}
        <hr
          style={{
            backgroundColor: colors.border,
            height: "2px",
            opacity: 0.5,
            margin: "2rem 0",
          }}
        />

        {/* Copyright & Legal */}
        <Row className="text-center">
          <Col>
            <p className="mb-2" style={{ opacity: 0.7 }}>
              &copy; {new Date().getFullYear()} Education Ireland - Irish Study
              Visa Probability Assessment Tool
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
